import React from 'react';
import PropTypes from 'prop-types';
import Switch from '@mui/material/Switch';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const SwitchCheckbox = (props) => {
  const {value, onChange, label, ...switchProps} = props;

  return (
    <Box gap={1}>
      <Switch
        checked={value}
        onChange={(event) => onChange(event.target.checked)}
        {...switchProps}
      />
      {label && (
        <Typography variant="body1" component="label">
          {label}
        </Typography>
      )}
    </Box>
  );
};

SwitchCheckbox.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired, // Callback to handle changes
  label: PropTypes.string, // Optional label above the switch
};

export default React.memo(SwitchCheckbox);
